import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=78459a36&lang=pug"
import script from "./Footer.vue?vue&type=script&lang=coffee"
export * from "./Footer.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports